import { Output, Input, EventEmitter, Component, PipeTransform, Pipe } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
declare var $: any;
//import * as jwt_decode from "jwt-decode";
import { DomSanitizer, SafeHtml, SafeStyle, SafeScript, SafeUrl, SafeResourceUrl } from '@angular/platform-browser';
import { AngularEditorConfig } from '@kolkov/angular-editor';

class BaseData {
  public ManikMyData: any = {};
  public ManikContext: string = "";
  public ManikLgContext: string = "";
  //Filter Params
  public ManikFilterParam1: string = "";
  public ManikFilterParam2: string = "";
  public ManikFilterParam3: string = "";
  public ManikFilterParam4: string = "";
  public ManikFilterParam5: string = "";
  public ManikFilterParam6: string = "";
  public ManikFilterParam7: string = "";
  public ManikFilterParam8: string = "";
  public ManikFilterParam9: string = "";
  public ManikFilterParam10: string = "";

  //File Varriable
  public ManikUploadedFile1: any;
  public ManikUploadedFile2: any;
  public ManikUploadedFile3: any;
  public ManikUploadedFile4: any;
  public ManikUploadedFile5: any;
  public ManikUploadedFile6: any;
  public ManikUploadedFile7: any;
  public ManikUploadedFile8: any;
  public ManikUploadedFile9: any;
  public ManikUploadedFile10: any;
  public ManikUploadedFileName1: any = {};
  public ManikUploadedFileName2: any = {};
  public ManikUploadedFileName3: any = {};
  public ManikUploadedFileName4: any = {};
  public ManikUploadedFileName5: any = {};
  public ManikUploadedFileName6: any = {};
  public ManikUploadedFileName7: any = {};
  public ManikUploadedFileName8: any = {};
  public ManikUploadedFileName9: any = {};
  public ManikUploadedFileName10: any = {};
  //private ManikFileUploadCount: number = 1;

  //Grid Params
  public PageSize: string = "10";
  public CurrentPage: string = "0";
  public OrderByColumnName: string = "";
  public SortOrder: string = "ASC";
  public SearchText: string = "";
  public SearchField: string = "";
  public Param1: string = "";
  public Param2: string = "";
  public Param3: string = "";
  public IsActiveMode: string = "Y";
  public RefreshData: boolean = true;
  public GridViewParams: any = {};
  public PageSizeOptions: number[] = [5, 10, 25, 50];
  public PageLength: number = 0;
  public manikLoadingResults: boolean = false;
  public FormSubmitted: boolean = false;
  public EndPoint="https://entityserver.manikworks.com/";
  public buttonEvent: any;

  //File Upload Attributes
  public errors: Array<string> = [];
  fileExt: string = "JPG, GIF, PNG, JPEG, TXT, HTML, HTM, PDF, XLS, XLSX";
  docExt: string = "TXT, HTML, HTM, PDF, ZIP";
  videoExt: string = "MP4, AVI, FLV, WMV, MOV";

  maxFiles: number = 10;
  maxSize: number = 10;
  uploadStatus = new EventEmitter();

  public ImageUrls: any = [];
  public minDate = new Date();
  public defaultStartDate = new Date();
  public defaultEndDate = new Date();
  public dateErrorMessage: any = { isError: false, errorMessage: '' };
  public ManikStartEndDateModel: any = { StartDate: null, EndDate: null };
  public StoreHandle: string;
  public AppRootUrl: any = location.origin + "/";

  public editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '100px',
    minHeight: '100px',
    placeholder: 'Enter text here...',
    showToolbar: true,
    fonts: [
      { name: "Vardana", class: "Vardana" },
      { name: "Arial", class: "Arial" },
      { name: "Nunito", class: "Nunito" },
      { name: "Roman", class: "Roman" },
      { name: "Google Ubuntu", class: "Google Ubuntu" }
    ]
  };

  constructor() { /*this.StoreHandle = sessionStorage.getItem("StoreHandle");*/ }
}

export class ManikEntityFE extends BaseData {
  public NoImageURL: string = "https://dkzxkcjlbnjui.cloudfront.net/sacredspace/no_image.jpg";
  public EndPoint="https://entityserver.manikworks.com/";
  constructor(public document: any) {
    super();
  }

  public updateFilterParams(param1: any, param2: any = "", param3: any = "", param4: any = "", param5: any = "", param6: any = "", param7: any = "", param8: any = "", param9: any = "", param10: any = ""): void {
    this.ManikFilterParam1 = param1;
    this.ManikFilterParam2 = param2;
    this.ManikFilterParam3 = param3;
    this.ManikFilterParam4 = param4;
    this.ManikFilterParam5 = param5;
    this.ManikFilterParam6 = param6;
    this.ManikFilterParam7 = param7;
    this.ManikFilterParam8 = param8;
    this.ManikFilterParam9 = param9;
    this.ManikFilterParam10 = param10;
  }

  public updateGridViewParams(params: any, value: any): void {
    switch (params) {
      case GridPrams.gv_PageSize:
        this.PageSize = value;
        break;
      case GridPrams.gv_CurrentPage:
        this.CurrentPage = value;
        break;
      case GridPrams.gv_OrderByColumnName:
        this.OrderByColumnName = value;
        break;
      case GridPrams.gv_SortOrder:
        this.SortOrder = value;
        break;
      case GridPrams.gv_SearchText:
        this.SearchText = value;
        break;
      case GridPrams.gv_SearchField:
        this.SearchField = value;
        break;
      case GridPrams.gv_Param1:
        this.Param1 = value;
        break;
      case GridPrams.gv_Param2:
        this.Param2 = value;
        break;
      case GridPrams.gv_Param3:
        this.Param3 = value;
        break;
      case GridPrams.gv_IsActiveMode:
        this.IsActiveMode = value;
        break;
    }
  }

  protected stringyfyFilterParams(): string {
    let stringyfiedString: string = this.ManikFilterParam1 + "_" + this.ManikFilterParam2 + "_" + this.ManikFilterParam3 + "_" + this.ManikFilterParam4
      + "_" + this.ManikFilterParam5 + "_" + this.ManikFilterParam6 + "_" + this.ManikFilterParam7 + "_" + this.ManikFilterParam8
      + "_" + this.ManikFilterParam9 + "_" + this.ManikFilterParam10;

    while (stringyfiedString[stringyfiedString.length - 1] === "_") {
      stringyfiedString = stringyfiedString.slice(0, -1);
    }

    return stringyfiedString;
  }

  public prepareLoadHeaders(filterparams: any, context: string = "", lgcontext: string = "", portalContext: string = "") {
    const headers = new HttpHeaders({
      'filterparams': filterparams,
      'context': context,
      'lgcontext': lgcontext,
      'portalcontext': portalContext
      // 'Authorization': 'Bearer ' + this.GetToken()
    });
    return headers;
  }

  public prepareLoadHeaders2(filterparams: any, context: string = "", lgcontext: string = "", portalContext: string = "") {
    const headers = new HttpHeaders({
      'EntityActionType':"GET.FORM.DATA",
      'QueryFilter': filterparams,
      'Context': context,
      'LGContext': lgcontext,
      // 'PortalContext': "ECOMM2",
      // 'PortalDS': PortalDS,
      'Authorization': 'Bearer ' + sessionStorage.getItem("sToken")
    });
    return headers;
  }

  public prepareManageHeaders(operation: string, context: string = "", lgcontext: string = "", portalcontext: string = "") {
    const headers = new HttpHeaders({
      'operation': operation,
      'context': context,
      'lgcontext': lgcontext,
      'portalcontext': portalcontext
    });
    return headers;
  }

  public prepareManageHeaders2(operation: string, context: string = "", lgcontext: string = "", portalcontext: string = "") {
    const headers = new HttpHeaders({
      'OperationMode': operation,
      'Context': context,
      'LGContext': lgcontext,
      'PortalContext': portalcontext,
      'EntityActionType':"ENTITY.MANAGER",
      'Authorization': 'Bearer ' + sessionStorage.getItem("sToken")
    });
    return headers;
  }

  public prepareAddlQueryHeaders(actioncontext: string, context: string = "", lgcontext: string = "", portalContext: string = "") {
    const headers = new HttpHeaders({
      'filterparams': this.stringyfyFilterParams(),
      'actioncontext': actioncontext,
      'context': context,
      'lgcontext': lgcontext,
      'PortalContext': 'EMCITY',
      'PortalDS': "EMCITY",
      'Authorization': 'Bearer ' + sessionStorage.getItem("sToken")
    });
    return headers;
  }

  public prepareAddlQueryHeaders2(actioncontext: string, context: string = "", lgcontext: string = "", portalContext: string = "") {
    const headers = new HttpHeaders({
      'QueryFilter': this.stringyfyFilterParams(),
      'EntityActionType': actioncontext,
      'Context': context,
      'LGContext': lgcontext,
      'PortalContext': 'EMCITY',
      'PortalDS': "EMCITY",
      // 'PortalContext': portalContext,
      'Authorization': 'Bearer ' + sessionStorage.getItem("sToken")
    });
    return headers;
  }

  public prepareEditHeaders(entityid: any, context: string = "", lgcontext: string = "", portalcontext: string = "") {
    const headers = new HttpHeaders({
      'entityid': entityid.toString(),
      'context': context,
      'lgcontext': lgcontext,
      'portalcontext': portalcontext
    });
    return headers;
  }

  public prepareEditHeaders2(entityid: any, context: string = "", lgcontext: string = "", portalcontext: string = "") {
    const headers = new HttpHeaders({
      'EntityActionType':'SINGLE.ENTITY',
      'QueryFilter':entityid? entityid.toString():entityid,
      'Context': context,
      'LGContext': lgcontext,
      'PortalContext': portalcontext,  
      'Authorization': 'Bearer ' + sessionStorage.getItem("sToken")
    });
    return headers;
  }

  public prepareGridViewHeaders(context: string = "", lgcontext: string = "") {
    this.GridViewParams[GridPrams.gv_PageSize] = this.PageSize;
    this.GridViewParams[GridPrams.gv_CurrentPage] = this.CurrentPage;
    this.GridViewParams[GridPrams.gv_OrderByColumnName] = this.OrderByColumnName;
    this.GridViewParams[GridPrams.gv_SortOrder] = this.SortOrder;
    this.GridViewParams[GridPrams.gv_SearchText] = this.SearchText;
    this.GridViewParams[GridPrams.gv_SearchField] = this.SearchField;
    this.GridViewParams[GridPrams.gv_Param1] = this.Param1;
    this.GridViewParams[GridPrams.gv_Param2] = this.Param2;
    this.GridViewParams[GridPrams.gv_Param3] = this.Param3;
    this.GridViewParams[GridPrams.gv_IsActiveMode] = this.IsActiveMode;
    const headers = new HttpHeaders({
      'gridviewparams': JSON.stringify(this.GridViewParams),
      'context': context,
      'lgcontext': lgcontext
    });
    return headers;
  }

  public prepareGridViewHeaders2(context: string = "", lgcontext: string = "", portalcontext: string = "") {
    this.GridViewParams[GridPrams.gv_PageSize] = this.PageSize;
    this.GridViewParams[GridPrams.gv_CurrentPage] = this.CurrentPage;
    this.GridViewParams[GridPrams.gv_OrderByColumnName] = this.OrderByColumnName;
    this.GridViewParams[GridPrams.gv_SortOrder] = this.SortOrder;
    this.GridViewParams[GridPrams.gv_SearchText] = this.SearchText;
    this.GridViewParams[GridPrams.gv_SearchField] = this.SearchField;
    this.GridViewParams[GridPrams.gv_Param1] = this.Param1;
    this.GridViewParams[GridPrams.gv_Param2] = this.Param2;
    this.GridViewParams[GridPrams.gv_Param3] = this.Param3;

    this.GridViewParams[GridPrams.gv_IsActiveMode] = this.IsActiveMode;
    const headers = new HttpHeaders({
      'ParamXML': JSON.stringify(this.GridViewParams),
      'QueryFilter':this.Param1,
      'EntityActionType': "GET.GRIDDATA.NOVA2",       
      'Context': context,
      'LGContext': lgcontext,      
      'PortalContext': portalcontext,      
      'Authorization': 'Bearer ' + sessionStorage.getItem("sToken")
    });
    return headers;
  }

  public prepareAPIRequestHeaders(apilgcontext: string, apicontext: string, param1: string = "", param2: string = "", param3: string = "") {
    const headers = new HttpHeaders({
      'apilgcontext': apilgcontext,
      'apicontext': apicontext,
      'param1': param1,
      'param2': param2,
      'param3': param3
    });
    return headers;
  }

  public prepareAPIRequestHeaders2(apilgcontext: string, apicontext: string, param1: string = "", param2: string = "", param3: string = "") {
    const headers = new HttpHeaders({
      'Param1':param1,
      'Param2':param2,
      'Param3':param3,    
      EntityActionType : 'API.REQUEST',
      Context : apicontext,
      LGContext : apilgcontext,
      'Authorization': 'Bearer ' + sessionStorage.getItem("sToken")
    });
    return headers;
  }

  public prepareImageUploadHeader(uploadDirectory: string, imageName: string, height: string = '', width: string = '', imageContext: string = '') {
    const headers = new HttpHeaders({
      'FolderPath': uploadDirectory,
      'FileName': imageName,
      'ImageHeight': height,
      'ImageWidth': width,
      'ImageContext': imageContext
    });
    return headers;
  }

  public prepareSmartImageTransferHeader(uploadDirectory: string, height: string, width: string, libImgURL: string) {
    const headers = new HttpHeaders({
      'FolderPath': uploadDirectory,
      'ImageHeight': height,
      'ImageWidth': width,
      'LibImgURL': libImgURL
    });
    return headers;
  }

  public prepareDocUploadHeader(uploadDirectory: string, docName: string = '') {
    const headers = new HttpHeaders({
      'FolderPath': uploadDirectory,
      'FileName': docName
    });
    return headers;
  }

  private isValidFiles(files: any) {
    if (files.length > this.maxFiles) {
      this.errors.push("Error: At a time you can upload only " + this.maxFiles + " files");
      return;
    }
    this.isValidFileExtension(files);
    return this.errors.length === 0;
  }

  private isValidFileExtension(files: any) {
    var extensions = (this.fileExt.split(','))
      .map(function (x) { return x.toLocaleUpperCase().trim() });
    for (var i = 0; i < files.length; i++) {
      var ext = files[i].name.toUpperCase().split('.').pop() || files[i].name;

      var exists: boolean = false;
      for (let i = 0; i < extensions.length - 1; i++) {
        if (extensions[i] == ext) {
          exists = true;
        }
      }
      if (!exists) {
        this.errors.push("Error (Extension): " + files[i].name);
      }
      this.isValidFileSize(files[i]);
    }
  }

  private isValidFileSize(file: any) {
    var fileSizeinMB = file.size / (1024 * 1000);
    var size = Math.round(fileSizeinMB * 100) / 100; // convert upto 2 decimal place
    if (size > this.maxSize)
      this.errors.push("Error (File Size): " + file.name + ": exceed file size limit of " + this.maxSize + "MB ( " + size + "MB )");
  }

  public imgPreview1(event: any, ctrlID: any, fileSerial: number) {
    let files = event.target.files;
    this.errors = [];
    if (files.length > 0 && (!this.isValidFiles(files))) {
      this.uploadStatus.emit(false);
      return;
    }
    var reader = new FileReader();

    reader.onload = (event: ProgressEvent) => {
      this.document.getElementById(ctrlID).setAttribute('src', (<FileReader>event.target).result);
    }

    reader.readAsDataURL(event.target.files[0]);

    let fileName: any = [];
    let formData: FormData = new FormData();
    for (var j = 0; j < files.length; j++) {
      formData.append("file[]", files[j], files[j].name);
      fileName[j] = files[j].name;
    }

    formData.append('metadata', new Blob([JSON.stringify(event.target)], { type: "application/json" }));

    switch (fileSerial) {
      case 1:
        this.ManikUploadedFile1 = formData;
        this.ManikUploadedFileName1 = fileName;
        break;
      case 2:
        this.ManikUploadedFile2 = formData;
        this.ManikUploadedFileName2 = fileName;
        break;
      case 3:
        this.ManikUploadedFile3 = formData;
        this.ManikUploadedFileName3 = fileName;
        break;
      case 4:
        this.ManikUploadedFile4 = formData;
        this.ManikUploadedFileName4 = fileName;
        break;
      case 5:
        this.ManikUploadedFile5 = formData;
        this.ManikUploadedFileName5 = fileName;
        break;
      case 6:
        this.ManikUploadedFile6 = formData;
        this.ManikUploadedFileName6 = fileName;
        break;
      case 7:
        this.ManikUploadedFile7 = formData;
        this.ManikUploadedFileName7 = fileName;
        break;
      case 8:
        this.ManikUploadedFile8 = formData;
        this.ManikUploadedFileName8 = fileName;
        break;
      case 9:
        this.ManikUploadedFile9 = formData;
        this.ManikUploadedFileName9 = fileName;
        break;
      case 10:
        this.ManikUploadedFile10 = formData;
        this.ManikUploadedFileName10 = fileName;
        break;
    }
  }
  public imgPreview(event: any, ctrlID: any, fileSerial: number) {
    let files = event.target.files;
    this.errors = [];
    if (files.length > 0 && (!this.isValidFiles(files))) {
      this.uploadStatus.emit(false);
      return;
    }
    var reader = new FileReader();

    reader.onload = (event: ProgressEvent) => {
      this.document.getElementById(ctrlID).setAttribute('src', (<FileReader>event.target).result);
    }

    reader.readAsDataURL(event.target.files[0]);

    let fileName: any = [];
    let formData: FormData = new FormData();
    for (var j = 0; j < files.length; j++) {
      formData.append("file[]", files[j], files[j].name);
      fileName[j] = files[j].name;
    }

    try {
      formData.append('metadata', new Blob([JSON.stringify(event.target)], { type: "application/json" }));
    }
    catch{
      formData.append('metadata', new Blob([event.target], { type: "application/json" }));
    }

    switch (fileSerial) {
      case 1:
        this.ManikUploadedFile1 = formData;
        this.ManikUploadedFileName1 = fileName;
        break;
      case 2:
        this.ManikUploadedFile2 = formData;
        this.ManikUploadedFileName2 = fileName;
        break;
      case 3:
        this.ManikUploadedFile3 = formData;
        this.ManikUploadedFileName3 = fileName;
        break;
      case 4:
        this.ManikUploadedFile4 = formData;
        this.ManikUploadedFileName4 = fileName;
        break;
      case 5:
        this.ManikUploadedFile5 = formData;
        this.ManikUploadedFileName5 = fileName;
        break;
      case 6:
        this.ManikUploadedFile6 = formData;
        this.ManikUploadedFileName6 = fileName;
        break;
      case 7:
        this.ManikUploadedFile7 = formData;
        this.ManikUploadedFileName7 = fileName;
        break;
      case 8:
        this.ManikUploadedFile8 = formData;
        this.ManikUploadedFileName8 = fileName;
        break;
      case 9:
        this.ManikUploadedFile9 = formData;
        this.ManikUploadedFileName9 = fileName;
        break;
      case 10:
        this.ManikUploadedFile10 = formData;
        this.ManikUploadedFileName10 = fileName;
        break;
    }
  }
  public FileUploadChange(event: any) {
    let files = event.target.files;
    this.errors = [];
    if (files.length > 0 && (!this.isValidFiles(files))) {
      this.uploadStatus.emit(false);
      return;
    }
    //var reader = new FileReader();

    // reader.onload = (event: ProgressEvent) => {
    //   this.document.getElementById(ctrlID).setAttribute('src', (<FileReader>event.target).result);
    // }

    //reader.readAsDataURL(event.target.files[0]);

    let fileName: any = [];
    let formData: FormData = new FormData();
    for (var j = 0; j < files.length; j++) {
      formData.append("file[]", files[j], files[j].name);
      fileName[j] = files[j].name;
    }
    try {
      formData.append('metadata', new Blob([JSON.stringify(event.target)], { type: "application/json" }));
    }
    catch{
      formData.append('metadata', new Blob([event.target], { type: "application/json" }));
    }

    if (!this.ManikUploadedFile1) {
      this.ManikUploadedFile1 = formData;
      this.ManikUploadedFileName1 = fileName;
    }
    else if (!this.ManikUploadedFile2) {
      this.ManikUploadedFile1 = formData;
      this.ManikUploadedFileName2 = fileName;
    }
    else if (!this.ManikUploadedFile3) {
      this.ManikUploadedFile3 = formData;
      this.ManikUploadedFileName3 = fileName;
    }
    else if (!this.ManikUploadedFile4) {
      this.ManikUploadedFile4 = formData;
      this.ManikUploadedFileName4 = fileName;
    }
    else if (!this.ManikUploadedFile5) {
      this.ManikUploadedFile5 = formData;
      this.ManikUploadedFileName5 = fileName;
    }
    else if (!this.ManikUploadedFile6) {
      this.ManikUploadedFile6 = formData;
      this.ManikUploadedFileName6 = fileName;
    }
    else if (!this.ManikUploadedFile7) {
      this.ManikUploadedFile7 = formData;
      this.ManikUploadedFileName7 = fileName;
    }
    else if (!this.ManikUploadedFile8) {
      this.ManikUploadedFile8 = formData;
      this.ManikUploadedFileName8 = fileName;
    }
    else if (!this.ManikUploadedFile9) {
      this.ManikUploadedFile9 = formData;
      this.ManikUploadedFileName9 = fileName;
    }
    else if (!this.ManikUploadedFile10) {
      this.ManikUploadedFile10 = formData;
      this.ManikUploadedFileName10 = fileName;
    }
  }
  //-------------Doc related function
  private isValidFilesDoc(files: any) {
    if (files.length > this.maxFiles) {
      this.errors.push("Error: At a time you can upload only " + this.maxFiles + " files");
      return;
    }
    this.isValidDocExtension(files);
    return this.errors.length === 0;
  }

  private isValidDocExtension(files: any) {
    var extensions = (this.docExt.split(','))
      .map(function (x) { return x.toLocaleUpperCase().trim() });
    for (var i = 0; i < files.length; i++) {
      var ext = files[i].name.toUpperCase().split('.').pop() || files[i].name;

      var exists: boolean = false;
      for (let i = 0; i < extensions.length - 1; i++) {
        if (extensions[i] == ext) {
          exists = true;
        }
      }
      if (!exists) {
        this.errors.push("Error (Extension): " + files[i].name);
      }
      this.isValidFileSize(files[i]);
    }
  }

  public docSetup(event: any, fileSerial: number) {
    let files = event.target.files;
    this.errors = [];
    if (files.length > 0 && (!this.isValidFilesDoc(files))) {
      this.uploadStatus.emit(false);
      return;
    }

    let fileName: any = [];
    let formData: FormData = new FormData();
    for (var j = 0; j < files.length; j++) {
      //formData.append("file[]", files[j], files[j].name);
      fileName[j] = files[j].name;
    }

    //for html -- { type: "text/html" } 'webmasterfile'
    //event.target.files.forEach(item => {
    //    formData.append('metadata', new Blob([item], { type: "application/json" }));
    //});
    formData.append('metadata', new Blob([event.target.files[0]], { type: "application/json" }));

    switch (fileSerial) {
      case 1:
        this.ManikUploadedFile1 = formData;
        this.ManikUploadedFileName1 = fileName;
        break;
      case 2:
        this.ManikUploadedFile2 = formData;
        this.ManikUploadedFileName2 = fileName;
        break;
      case 3:
        this.ManikUploadedFile3 = formData;
        this.ManikUploadedFileName3 = fileName;
        break;
      case 4:
        this.ManikUploadedFile4 = formData;
        this.ManikUploadedFileName4 = fileName;
        break;
      case 5:
        this.ManikUploadedFile5 = formData;
        this.ManikUploadedFileName5 = fileName;
        break;
      case 6:
        this.ManikUploadedFile6 = formData;
        this.ManikUploadedFileName6 = fileName;
        break;
      case 7:
        this.ManikUploadedFile7 = formData;
        this.ManikUploadedFileName7 = fileName;
        break;
      case 8:
        this.ManikUploadedFile8 = formData;
        this.ManikUploadedFileName8 = fileName;
        break;
      case 9:
        this.ManikUploadedFile9 = formData;
        this.ManikUploadedFileName9 = fileName;
        break;
      case 10:
        this.ManikUploadedFile10 = formData;
        this.ManikUploadedFileName10 = fileName;
        break;
    }
  }

  public refreshUploadSets() {
    this.ManikUploadedFile1 = null;
    this.ManikUploadedFileName1 = null;
    this.ManikUploadedFile2 = null;
    this.ManikUploadedFileName2 = null;
    this.ManikUploadedFile3 = null;
    this.ManikUploadedFileName3 = null;
    this.ManikUploadedFile4 = null;
    this.ManikUploadedFileName4 = null;
    this.ManikUploadedFile5 = null;
    this.ManikUploadedFileName5 = null;
    this.ManikUploadedFile6 = null;
    this.ManikUploadedFileName6 = null;
    this.ManikUploadedFile7 = null;
    this.ManikUploadedFileName7 = null;
    this.ManikUploadedFile8 = null;
    this.ManikUploadedFileName8 = null;
    this.ManikUploadedFile9 = null;
    this.ManikUploadedFileName9 = null;
    this.ManikUploadedFile10 = null;
    this.ManikUploadedFileName10 = null;
  }
  //-------------Doc related function end

  //-------------Video related function
  private isValidFilesVideo(files: any) {
    if (files.length > this.maxFiles) {
      this.errors.push("Error: At a time you can upload only " + this.maxFiles + " files");
      return;
    }
    this.isValidVideoExtension(files);
    return this.errors.length === 0;
  }

  private isValidVideoExtension(files: any) {
    var extensions = (this.videoExt.split(','))
      .map(function (x) { return x.toLocaleUpperCase().trim() });
    for (var i = 0; i < files.length; i++) {
      var ext = files[i].name.toUpperCase().split('.').pop() || files[i].name;

      var exists: boolean = false;
      for (let i = 0; i < extensions.length - 1; i++) {
        if (extensions[i] == ext) {
          exists = true;
        }
      }
      if (!exists) {
        this.errors.push("Error (Extension): " + files[i].name);
      }
      this.isValidFileSize(files[i]);
    }
  }

  public videoSetup(event: any, fileSerial: number, classname: string = '', id: string = '') {
    let files = event.target.files;
    this.errors = [];
    if (files.length > 0 && (!this.isValidFilesVideo(files))) {
      this.uploadStatus.emit(false);
      return;
    }

    if (classname != '') {
      var reader = new FileReader();
      let elarray = this.document.getElementsByClassName(classname);
      for (let i = 0; i < elarray.length; i++) {
        elarray[i].setAttribute('src', window.URL.createObjectURL(files[0]));
      }
      this.document.getElementById(id).setAttribute('src', window.URL.createObjectURL(files[0]));
      reader.readAsDataURL(event.target.files[0]);
    }

    let fileName: any = [];
    let formData: FormData = new FormData();
    for (var j = 0; j < files.length; j++) {
      fileName[j] = files[j].name;
    }
    formData.append('metadata', new Blob([event.target.files[0]], { type: "application/json" }));

    switch (fileSerial) {
      case 1:
        this.ManikUploadedFile1 = formData;
        this.ManikUploadedFileName1 = fileName;
        break;
      case 2:
        this.ManikUploadedFile2 = formData;
        this.ManikUploadedFileName2 = fileName;
        break;
      case 3:
        this.ManikUploadedFile3 = formData;
        this.ManikUploadedFileName3 = fileName;
        break;
      case 4:
        this.ManikUploadedFile4 = formData;
        this.ManikUploadedFileName4 = fileName;
        break;
      case 5:
        this.ManikUploadedFile5 = formData;
        this.ManikUploadedFileName5 = fileName;
        break;
      case 6:
        this.ManikUploadedFile6 = formData;
        this.ManikUploadedFileName6 = fileName;
        break;
      case 7:
        this.ManikUploadedFile7 = formData;
        this.ManikUploadedFileName7 = fileName;
        break;
      case 8:
        this.ManikUploadedFile8 = formData;
        this.ManikUploadedFileName8 = fileName;
        break;
      case 9:
        this.ManikUploadedFile9 = formData;
        this.ManikUploadedFileName9 = fileName;
        break;
      case 10:
        this.ManikUploadedFile10 = formData;
        this.ManikUploadedFileName10 = fileName;
        break;
    }
  }
  //-------------Video related function end

  public showNotification(from, align, alerttype, msg, title = "") {
    $.notify({
      icon: "notifications",
      title: title,
      message: msg

    }, {
      type: alerttype,
      timer: 100,
      placement: {
        from: from,
        align: align
      },
      template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
        '<button class="close mat-button" data-notify="dismiss">  <i class="fa fa-times"></i></button>' +
        '<i class="fa fa-bell" data-notify="icon"></i> ' +
        '<span data-notify="title">{1}</span> ' +
        '<span data-notify="message">{2}</span>' +
        '<div class="progress" data-notify="progressbar">' +
        '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
        '</div>' +
        '<a href="{3}" target="{4}" data-notify="url"></a>' +
        '</div>'
    });
  }

  // public PreSubmit(event: any): void {
  //   event.target.classList.add('manik-loader');
  //   //event.target.classList.add('pending');
  //   var inputs = this.document.getElementsByTagName("INPUT");
  //   for (var i in inputs) {
  //     if (inputs[i].type == "button" || inputs[i].type == "submit"
  //       || inputs[i].type == "text" || inputs[i].type == "email"
  //       || inputs[i].type == "password" || inputs[i].type == "checkbox")
  //       inputs[i].disabled = true;
  //   }
  // }

  // public PostSubmit(event: any, enableAll: boolean = true): void {
  //   event.target.classList.remove('manik-loader');
  //   // event.target.classList.remove('pending');
  //   event.srcElement.removeAttribute('disabled');

  //   var inputs = this.document.getElementsByTagName("INPUT");
  //   for (var i in inputs) {
  //     if (enableAll) {
  //       if (inputs[i].type == "button" || inputs[i].type == "submit"
  //         || inputs[i].type == "text" || inputs[i].type == "email"
  //         || inputs[i].type == "password" || inputs[i].type == "checkbox")
  //         inputs[i].disabled = false;
  //     }
  //   }
  // }

  public manikInteger(event: any) {
    let regexStr = '^[0-9]*$';
    let e = <KeyboardEvent>event;
    if ([8, 9, 27, 13].indexOf(e.keyCode) !== -1 ||
      (e.keyCode === 65 && (e.ctrlKey || e.metaKey)) ||
      (e.keyCode === 67 && (e.ctrlKey || e.metaKey)) ||
      (e.keyCode === 86 && (e.ctrlKey || e.metaKey)) ||
      (e.keyCode === 88 && (e.ctrlKey || e.metaKey)) ||
      (e.keyCode === 39 && (e.ctrlKey || e.metaKey))) {
      return;
    }
    let ch = String.fromCharCode(e.keyCode);
    let regEx = new RegExp(regexStr);
    if (regEx.test(ch))
      return;
    else
      e.preventDefault();
  }

  public manikDecimal(event: any) {
    let regexStr = '^[0-9]*$';
    let e = <KeyboardEvent>event;
    if ([46, 8, 9, 27, 13, 110].indexOf(e.keyCode) !== -1 ||
      (e.keyCode === 65 && (e.ctrlKey || e.metaKey)) ||
      (e.keyCode === 67 && (e.ctrlKey || e.metaKey)) ||
      (e.keyCode === 86 && (e.ctrlKey || e.metaKey)) ||
      (e.keyCode === 88 && (e.ctrlKey || e.metaKey)) ||
      (e.keyCode === 39 && (e.ctrlKey || e.metaKey))) {
      return;
    }
    let ch = String.fromCharCode(e.keyCode);
    let regEx = new RegExp(regexStr);
    if (regEx.test(ch))
      return;
    else
      e.preventDefault();
  }

  public validateStartAndEndDates(event: any, dateType: string): string {
    this.dateErrorMessage.isError = false;
    if (dateType === 'ED' && !this.ManikStartEndDateModel.StartDate) {
      event.target.value = '';
      this.dateErrorMessage.isError = true;
      // this.dateErrorMessage.errorMessage = 'end date can\'t before start date';
      this.ManikStartEndDateModel.EndDate = null;
      return 'ED';
    }
    else if (new Date(this.ManikStartEndDateModel.StartDate) > new Date(this.ManikStartEndDateModel.EndDate) && this.ManikStartEndDateModel.EndDate) {
      this.dateErrorMessage.isError = true;
      //this.dateErrorMessage.errorMessage = 'end date can\'t be lower than start date';
      event.target.value = '';
      this.ManikStartEndDateModel.EndDate = null;
      return 'SD';
    }
  }

  public showToolBar(editorNo: any) {
    let control: any = this.document.getElementsByClassName("angular-editor-toolbar");
    control[editorNo].hidden = false;
  }

  public hideToolBar() {
    let control: any = this.document.getElementsByClassName("angular-editor-toolbar");
    for (let i = 0; i < control.length; i++) {
      control[i].hidden = true;
    }
  }

  // protected ManikGetFileNameFromURL(sUrl: string) {
  //   sUrl = sUrl.replace("\\", "/");
  //   return sUrl.substring(sUrl.lastIndexOf('/') + 1).toLowerCase();
  // }

  protected manikGetFileExtFromName(imageName: string): string {
    return imageName.split('.').pop();
  }

  public copyToClipboard(val: string) {
    let selBox = document.createElement('textarea');
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }

  protected getManikDateString(date: any): string {
    let newDate: Date = new Date(date);
    return ((newDate.getMonth() + 1) + '-' + newDate.getDate() + '-' + newDate.getFullYear());
  }

  protected getValidUrl(url: string): string {
    if (url.includes("http://")) {
      return url;
    }
    else {
      return "http://" + url;
    }
  }

  protected BindJS(jsUrl): void {
    let el1 = document.createElement('script');
    el1.setAttribute('src', jsUrl);
    document.body.appendChild(el1);
  }

  protected BindCSS(e: any, t: any = null, n: any = null) {
    // "use strict";
    var i = window.document.createElement("link");
    var o = t || window.document.getElementsByTagName("script")[0];
    i.rel = "stylesheet";
    i.href = e;
    i.media = "only x";
    o.parentNode.insertBefore(i, o);
    setTimeout(function () { i.media = n || "all" });
  }

  public PreSubmit(event: any): void {
    this.FormSubmitted = true;
    event.target.classList.add('manik-loader');
    var inputs = this.document.getElementsByTagName("INPUT");
    for (var i in inputs) {
      if (inputs[i].type == "button" || inputs[i].type == "submit"
        || inputs[i].type == "text" || inputs[i].type == "email"
        || inputs[i].type == "password" || inputs[i].type == "checkbox")
        inputs[i].disabled = true;
    }
  }

  public PostSubmit(event: any, enableAll: boolean = true): void {
    this.FormSubmitted = false;
    event.target.classList.remove('manik-loader');
    // event.target.classList.remove('pending');
    event.srcElement.removeAttribute('disabled');

    var inputs = this.document.getElementsByTagName("INPUT");
    for (var i in inputs) {
      if (enableAll) {
        if (inputs[i].type == "button" || inputs[i].type == "submit"
          || inputs[i].type == "text" || inputs[i].type == "email"
          || inputs[i].type == "password" || inputs[i].type == "checkbox")
          inputs[i].disabled = false;
      }
    }
  }

  InitCaptcha(CaptchaHolder, CaptchaDivID, grecaptcha) {
    CaptchaHolder = grecaptcha.render(CaptchaDivID, {
      'sitekey': '6Le3BbkUAAAAAGNMzPm4nEe-hm1W2HB6PQe8YFD3'
    });//Try keeping this in environment.ts
  }
}

export class GridPrams {
  public static get gv_PageSize(): string { return "PageSize" };
  public static get gv_CurrentPage(): string { return "CurrentPage" };
  public static get gv_OrderByColumnName(): string { return "OrderByColumn" };
  public static get gv_SortOrder(): string { return "SortOrder" };
  public static get gv_SearchText(): string { return "SearchText" };
  public static get gv_SearchField(): string { return "SearchField" };
  public static get gv_Param1(): string { return "param1" };
  public static get gv_Param2(): string { return "param2" };
  public static get gv_Param3(): string { return "param3" };
  public static get gv_IsActiveMode(): string { return "IsActiveMode" };
}

export class CookieManager {

  public static getCookie(name: string) {
    let ca: Array<string> = document.cookie.split(';');
    let caLen: number = ca.length;
    let cookieName = `${name}=`;
    let c: string;

    for (let i: number = 0; i < caLen; i += 1) {
      c = ca[i].replace(/^\s+/g, '');
      if (c.indexOf(cookieName) == 0) {

        return c.substring(cookieName.length, c.length);
      }
    }
    return '';
  }

  public static deleteCookie(name: string) {
    this.setCookie(name, '', -1);
  }

  public static setCookie(name: string, value: string, expireDays: number, path: string = '') {
    let d: Date = new Date();
    d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
    let expires: string = `expires=${d.toUTCString()}`;
    let cpath: string = path ? `; path=${path}` : '';
    document.cookie = `${name}=${value}; ${expires}${cpath}`;
  }

  public static decodeAccessToken(token: string): any {
    // try {
    //   return jwt_decode(token);
    // }
    // catch (Error) {
    //   return null;
    // }
  }
}

@Component({
  selector: 'ManikButtonLoader',
  template: `<div class="manik-button-loader">
  <div></div>
  <div></div>
  <div></div>
  <div></div>
</div>`
})
export class ManikButtonLoader {
  constructor() { }
}

@Pipe({
  name: 'safe'
})
export class GenericSafePipe implements PipeTransform {

  constructor(public sanitizer: DomSanitizer) { }

  public transform(value: any, type: string): SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl {
    switch (type) {
      case 'html': return this.sanitizer.bypassSecurityTrustHtml(value);
      case 'style': return this.sanitizer.bypassSecurityTrustStyle(value);
      case 'script': return this.sanitizer.bypassSecurityTrustScript(value);
      case 'url': return this.sanitizer.bypassSecurityTrustUrl(value);
      case 'resourceUrl': return this.sanitizer.bypassSecurityTrustResourceUrl(value);
      default: throw new Error(`Invalid safe type specified: ${type}`);
    }
  }
}